<div class="container">
  <div class="page-header">
    <div class="page-header-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="3" width="7" height="7" rx="1.5" />
        <rect x="14" y="3" width="7" height="7" rx="1.5" />
        <rect x="3" y="14" width="7" height="7" rx="1.5" />
        <rect x="14" y="14" width="7" height="7" rx="1.5" />
      </svg>
    </div>
    <div class="page-header-textos">
      <h1>Lista de Produtos</h1>
      <p>Todos os produtos cadastrados no Sankhya</p>
    </div>
    <button type="button" class="btn primary" (click)="onNovoProduto()">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="12" y1="5" x2="12" y2="19" />
        <line x1="5" y1="12" x2="19" y2="12" />
      </svg>
      Cadastrar
    </button>
    <div class="header-funcoes" (click)="$event.stopPropagation()">
      <button type="button" class="btn-config" (click)="toggleFuncoesMenu($event)" title="Funções">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="3"></circle>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
        </svg>
      </button>
      <div class="pcf-funcoes-menu" *ngIf="funcoesMenuAberto">
        <button type="button" class="pcf-funcoes-item" (click)="abrirModalMargem()">Atualizar Margem de Custo/Lucro</button>
        <div class="pcf-funcoes-sub">
          <button type="button" class="pcf-funcoes-item pcf-funcoes-item-sub">Atualizar Tabela de Preços - Arquivo<span class="pcf-seta">&#9656;</span></button>
          <div class="pcf-funcoes-submenu">
            <button type="button" class="pcf-funcoes-item" (click)="acaoFuncaoPreco('TABELA_PRECOS', 'VARIAVEL')">Valor Variável</button>
            <button type="button" class="pcf-funcoes-item" (click)="acaoFuncaoPreco('TABELA_PRECOS', 'FIXO')">Valor Fixo</button>
          </div>
        </div>
        <div class="pcf-funcoes-separador"></div>
        <button type="button" class="pcf-funcoes-item" (click)="exportarExcel()" [disabled]="exportando">Exportar Dados para Excel</button>
        <button type="button" class="pcf-funcoes-item" (click)="exportarCsv()" [disabled]="exportando">Exportar Dados para CSV</button>
        <button type="button" class="pcf-funcoes-item" (click)="copiarParaAreaDeTransferencia()" [disabled]="exportando">Copiar Dados para Área de Transferência</button>
      </div>
    </div>
  </div>

  <div class="loading-overlay" *ngIf="processandoMargem">
    <app-loading-indicator></app-loading-indicator>
    <span class="loading-text">{{ margemMsg }} {{ margemPct }}%</span>
    <div class="export-barra"><div class="export-barra-preench" [style.width.%]="margemPct"></div></div>
  </div>

  <div class="mg-overlay" *ngIf="modalMargemAberto" (click)="fecharModalMargem()">
    <div class="mg-box" (click)="$event.stopPropagation()">
      <div class="mg-header">
        <span>Recalcular Custo/Lucro</span>
        <button type="button" class="mg-fechar" (click)="fecharModalMargem()" title="Sair">×</button>
      </div>

      <ng-container *ngIf="!margemEtapaConfirmar">
        <div class="mg-corpo">
          <div class="mg-linha">
            <label class="mg-campo mg-campo-largo">
              <span>Alterar Margem de</span>
              <select [(ngModel)]="margemAlterar">
                <option *ngFor="let o of opcoesMargem" [value]="o.id">{{ o.label }}</option>
              </select>
            </label>
            <label class="mg-campo">
              <span>Atualizar</span>
              <select [(ngModel)]="margemAtualizar" (ngModelChange)="onMargemAtualizarChange()">
                <option value="FABRICANTE">Por Fabricante</option>
                <option value="TODOS">Todos os produtos</option>
              </select>
            </label>
            <label class="mg-campo">
              <span>Fator</span>
              <select disabled>
                <option>Definir para</option>
              </select>
            </label>
          </div>

          <div class="mg-linha mg-linha-valores">
            <label class="mg-campo mg-campo-valor" *ngIf="opcaoMargem.custo">
              <span>{{ rotuloCustoMargem }}</span>
              <input type="text" inputmode="decimal" [(ngModel)]="margemCusto" placeholder="0,00" (keydown.enter)="margemOk()">
            </label>
            <label class="mg-campo mg-campo-valor" *ngIf="opcaoMargem.lucro">
              <span>{{ rotuloLucroMargem }}</span>
              <input type="text" inputmode="decimal" [(ngModel)]="margemLucro" placeholder="0,00" (keydown.enter)="margemOk()">
            </label>
          </div>

          <div class="mg-linha">
            <div class="mg-campo mg-campo-largo">
              <span>Fabricante</span>
              <div class="mg-fab-wrap" [class.mg-fab-desab]="margemAtualizar !== 'FABRICANTE'"
                   (click)="abrirModalMarcaMargem()">
                <span class="mg-fab-lupa"><span class="fabricante-lupa"></span></span>
                <input type="text" readonly
                       [value]="margemCodMarca ? (margemCodMarca + (margemNomeMarca ? ' - ' + margemNomeMarca : '')) : ''"
                       [disabled]="margemAtualizar !== 'FABRICANTE'"
                       placeholder="Clique para selecionar o fabricante">
                <button type="button" class="mg-fab-limpar" *ngIf="margemCodMarca && margemAtualizar === 'FABRICANTE'"
                        (click)="$event.stopPropagation(); margemCodMarca = ''; margemNomeMarca = ''" title="Limpar">
                  <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="mg-erro" *ngIf="margemErro">{{ margemErro }}</div>
        </div>
        <div class="mg-rodape">
          <button type="button" class="btn primary" (click)="margemOk()">Ok</button>
          <button type="button" class="btn secondary" (click)="fecharModalMargem()">Sair</button>
        </div>
      </ng-container>

      <ng-container *ngIf="margemEtapaConfirmar">
        <div class="mg-corpo">
          <p class="mg-confirma">{{ resumoMargem }}</p>
          <p class="mg-aviso">Esta alteração é em massa (Sankhya e Aerosys) e não pode ser desfeita automaticamente. Deseja continuar?</p>
        </div>
        <div class="mg-rodape">
          <button type="button" class="btn primary" (click)="confirmarMargem()">Confirmar</button>
          <button type="button" class="btn secondary" (click)="margemEtapaConfirmar = false">Voltar</button>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="mg-overlay mg-overlay-marca" *ngIf="modalMarcaMargemAberto" (click)="modalMarcaMargemAberto = false">
    <div class="mg-box mg-box-marca" (click)="$event.stopPropagation()">
      <div class="mg-header"><span>Procurando por Marca</span></div>
      <div class="mg-corpo">
        <input type="text" class="mg-marca-input" [(ngModel)]="filtroMarcaMargem" placeholder="Digite o que você procura">
        <div class="mg-marca-lista">
          <div class="mg-marca-item" *ngFor="let m of marcasMargemFiltradas" (click)="selecionarMarcaMargem(m)">{{ m.label }}</div>
          <div class="mg-marca-vazio" *ngIf="!marcasMargemFiltradas.length">Nenhuma marca encontrada.</div>
        </div>
      </div>
      <div class="mg-rodape"><button type="button" class="btn secondary" (click)="modalMarcaMargemAberto = false">Cancelar</button></div>
    </div>
  </div>

  <div class="loading-overlay" *ngIf="exportando">
    <app-loading-indicator></app-loading-indicator>
    <span class="loading-text">{{ exportandoMsg }} {{ exportandoPct }}%</span>
    <div class="export-barra"><div class="export-barra-preench" [style.width.%]="exportandoPct"></div></div>
  </div>

  <div class="modal-fil-overlay" *ngIf="modalFiliaisAberto" (click)="fecharEstoqueFiliais()">
    <div class="modal-fil" (click)="$event.stopPropagation()">
      <div class="modal-fil-header">
        <div class="modal-fil-titulo" *ngIf="modalFiliaisProduto">
          <div class="modal-fil-pn">P/N: {{ modalFiliaisProduto.refforn || '—' }}</div>
          <div class="modal-fil-desc">{{ modalFiliaisProduto.descricao }}</div>
          <div class="modal-fil-cod">Código: {{ codProdStr(modalFiliaisProduto) }}</div>
        </div>
        <button type="button" class="modal-fil-fechar" (click)="fecharEstoqueFiliais()" title="Fechar">×</button>
      </div>
      <div class="modal-fil-corpo">
        <div class="modal-fil-carregando" *ngIf="modalFiliaisCarregando">
          <app-loading-indicator></app-loading-indicator>
          <span>Carregando estoque das filiais...</span>
        </div>
        <div class="lista-erro" *ngIf="!modalFiliaisCarregando && modalFiliaisErro">{{ modalFiliaisErro }}</div>
        <table class="tabela" *ngIf="!modalFiliaisCarregando && modalFiliaisItens.length">
          <thead>
            <tr><th>Filial</th><th class="fil-col-estoque">Estoque</th><th class="fil-col-local">Local</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let f of modalFiliaisItens" [class.fil-atual]="f.atual">
              <td>{{ f.empresaId }} - {{ f.empresa }}<span class="fil-atual-tag" *ngIf="f.atual">atual</span></td>
              <td class="fil-col-estoque">{{ f.qtde | number:'1.0-2':'pt-BR' }}</td>
              <td class="fil-col-local">{{ f.local || '—' }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr *ngIf="modalFiliaisSemSaldoOutras"><td colspan="3" class="fil-sem-saldo">Nenhuma outra filial com saldo deste item.</td></tr>
            <tr><td><strong>Total</strong></td><td class="fil-col-estoque"><strong>{{ totalEstoqueFiliais | number:'1.0-2':'pt-BR' }}</strong></td><td class="fil-col-local"></td></tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>

  <div class="modal-fil-overlay" *ngIf="modalCotAberto" (click)="fecharCotacoes()">
    <div class="modal-fil cot-modal" (click)="$event.stopPropagation()">
      <button type="button" class="cot-fechar" (click)="fecharCotacoes()" title="Fechar">×</button>
      <div class="modal-fil-corpo">
        <div class="modal-fil-carregando" *ngIf="modalCotCarregando">
          <app-loading-indicator></app-loading-indicator>
          <span>Carregando cotações...</span>
        </div>
        <div class="lista-erro" *ngIf="!modalCotCarregando && modalCotErro">{{ modalCotErro }}</div>
        <!-- Mesma linha de precos da tela de Edicao (somente leitura) -->
        <div class="cot-grid" *ngFor="let c of modalCotItens" [class.cot-nacional]="cotNacional">
          <div class="cot-campo"><div class="cot-rotulo">PREÇO FABRICANTE {{ cotNacional ? 'R$' : 'U$' }}</div><input type="text" readonly [value]="c.preco | number:'1.2-2':'en-US'"></div>
          <div class="cot-campo"><div class="cot-rotulo">CUSTO (%)</div><input type="text" readonly [value]="c.custoPct | number:'1.2-2':'en-US'"></div>
          <div class="cot-campo"><div class="cot-rotulo">TOTAL CUSTO {{ cotNacional ? 'R$' : 'U$' }}</div><input type="text" readonly class="cot-calc" [value]="c.totalCusto | number:'1.2-2':'en-US'"></div>
          <div class="cot-campo"><div class="cot-rotulo">LUCRO (%)</div><input type="text" readonly [value]="c.lucroPct | number:'1.2-2':'en-US'"></div>
          <div class="cot-campo"><div class="cot-rotulo">PREÇO VENDA {{ cotNacional ? 'R$' : 'U$' }}</div><input type="text" readonly class="cot-calc" [value]="c.venda | number:'1.2-2':'en-US'"></div>
          <div class="cot-campo" *ngIf="!cotNacional">
            <div class="cot-rotulo">PREÇO VENDA R$
              <small *ngIf="cotacaoDolar > 0">(COTAÇÃO: U$ {{ cotacaoDolar | number:'1.2-2':'pt-BR' }})</small>
            </div>
            <input type="text" readonly class="cot-calc" [value]="c.vendaReais != null ? (c.vendaReais | number:'1.2-2':'en-US') : '—'">
          </div>
          <div class="cot-campo cot-core">
            <span class="cot-toggle" [class.on]="c.core > 0"><i></i></span>
            <div class="cot-core-col">
              <div class="cot-rotulo">CORE {{ cotNacional ? 'R$' : 'U$' }}</div>
              <input type="text" readonly class="cot-calc" [value]="c.core | number:'1.2-2':'en-US'">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="toast-funcoes" *ngIf="avisoFuncoes" [class.toast-erro]="avisoErro">{{ avisoFuncoes }}</div>

  <div class="card">
    <div class="lista-toolbar">
      <div class="field field-wide">
        <input type="text" [(ngModel)]="termoBusca" (ngModelChange)="onTermoBuscaChange()"
          aria-label="Pesquisar na lista de produtos"
          placeholder="Pesquisar por código, status, PN, descrição, fabricante, CD, unidade, serial, NCM, label ou grupo...">
      </div>
      <button type="button" class="btn secondary" (click)="onAtualizar()" [disabled]="carregando"
        title="Recarregar a lista de produtos">
        Atualizar
      </button>
    </div>

    <div class="lista-carregando" *ngIf="carregando">
      <app-loading-indicator size="inline"></app-loading-indicator>
      <span>Carregando produtos...</span>
    </div>

    <div class="lista-erro" *ngIf="erro && !carregando">{{ erro }}</div>

    <ng-container *ngIf="!carregando && !erro">
      <div class="lista-vazia" *ngIf="!produtosFiltrados.length">
        Nenhum produto encontrado.
      </div>

      <div class="tabela-card" *ngIf="produtosFiltrados.length">
        <table class="tabela">
          <thead>
            <tr>
              <th>Código</th>
              <th class="col-status">Status</th>
              <th>CD</th>
              <th>PN</th>
              <th>Descrição</th>
              <th>Fabricante</th>
              <th class="col-valor">Fab. U$/R$</th>
              
              <th class="col-status">Unidade</th>
              <th class="col-valor">U$+IPI</th>
              <th class="col-valor">R$+IPI</th>
              <th class="col-status">Estoque</th>
              <th>Local</th>
              <th class="col-valor">Core U$</th>
              <th>Serial</th>
              <th>NCM</th>
              <th>LABEL</th>
              <th>ECCN</th>
              <th>Schedule B</th>
              <th>Grupo</th>
              <th class="ds-table-cell--actions" style="text-transform: uppercase;">AÇÕES</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of produtosPagina" (click)="linhaSelecionada = p" (dblclick)="onEditar(p)" title="Duplo clique para editar"
                [class.linha-selecionada]="linhaSelecionada === p"
                [class.linha-sem-preco]="!p.vlrVenda || p.vlrVenda <= 0"
                [class.linha-preco-desatualizado]="p.precoDesatualizado && p.vlrVenda && p.vlrVenda > 0">
              <td>{{ codProdStr(p) }}</td>
              <td class="col-status">
                <span class="status-dot" [class.inativo]="!isAtivo(p)"
                      [title]="isAtivo(p) ? 'Ativo' : 'Inativo'"
                      [attr.aria-label]="isAtivo(p) ? 'Ativo' : 'Inativo'"></span>
              </td>
              <td>{{ p.ad_condicao || '—' }}</td>
              <td class="col-pn-copiar" title="Clique para copiar o PN" (click)="copiarPn(p)">{{ p.refforn || '—' }}</td>
              <td class="col-descricao">{{ p.descricao || '—' }}</td>
              <td>{{ p.marca || '—' }}</td>
              <td class="col-valor col-preco-fab" title="Clique para ver as últimas 3 cotações" (click)="abrirCotacoes(p, $event)">{{ p.precoFab && p.precoFab > 0 ? (p.precoFab | number:'1.2-2':'pt-BR') : '—' }}</td>
              <td class="col-status">{{ p.codvol || '—' }}</td>
              <td class="col-valor">{{ vendaMoeda(p) != null ? (vendaMoeda(p) | number:'1.2-2':'pt-BR') : '—' }}</td>
              <td class="col-valor">{{ vendaReais(p) != null ? (vendaReais(p) | number:'1.2-2':'pt-BR') : '—' }}</td>
              <td class="col-status col-estoque" (click)="abrirEstoqueFiliais(p, $event)" title="Ver estoque nas demais filiais">
                <app-loading-indicator *ngIf="p.estoqueAerosys === undefined && carregandoEstoque" size="inline" class="cel-loading"></app-loading-indicator>
                <ng-container *ngIf="!(p.estoqueAerosys === undefined && carregandoEstoque)">{{ p.estoqueAerosys != null ? (p.estoqueAerosys | number:'1.0-2':'pt-BR') : '—' }}</ng-container>
              </td>
              <td>
                <app-loading-indicator *ngIf="p.estoqueAerosys === undefined && carregandoEstoque" size="inline" class="cel-loading"></app-loading-indicator>
                <ng-container *ngIf="!(p.estoqueAerosys === undefined && carregandoEstoque)">{{ p.localAerosys || '—' }}</ng-container>
              </td>
              <td class="col-valor">
                <app-loading-indicator *ngIf="p.estoqueAerosys === undefined && carregandoEstoque" size="inline" class="cel-loading"></app-loading-indicator>
                <ng-container *ngIf="!(p.estoqueAerosys === undefined && carregandoEstoque)">{{ p.coreAerosys ? (p.coreAerosys | number:'1.2-2':'pt-BR') : '—' }}</ng-container>
              </td>
              <td>{{ p.tipcontest === 'E' ? 'S' : 'N' }}</td>
              <td>{{ p.ncm || '—' }}</td>
              <td>{{ p.gpl_label || '—' }}</td>
              <td>{{ p.ad_eccn || '—' }}</td>
              <td>{{ p.ad_scheduleb || '—' }}</td>
              <td>{{ getNomeGrupo(p.codgrupoprod) }}</td>
              <td class="ds-table-cell--actions" (click)="$event.stopPropagation()">
                <div class="ds-dropdown">
                  <button type="button" 
                          style="background: transparent; border: 0; color: #64748b; font-size: 20px; font-weight: bold; cursor: pointer; padding: 4px 8px; border-radius: 4px;"
                          (click)="toggleMenuAcoes(p, $event)"
                          title="Ações">
                    ⋮
                  </button>
                  <div class="ds-dropdown-menu" *ngIf="menuAberto === p"
                       [style.position]="'fixed'" [style.top.px]="menuPos?.top" [style.right.px]="menuPos?.right">
                    <button type="button" class="ds-dropdown-item" (click)="onEditar(p); menuAberto = null">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M12 20h9" />
                        <path d="M16.5 3.5a2.12 2.12 0 1 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
                      </svg>
                      Editar Produto
                    </button>
                    <button type="button" class="ds-dropdown-item" (click)="onClonar(p); menuAberto = null">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="9" y="9" width="11" height="11" rx="2" />
                        <path d="M5 15V6a2 2 0 0 1 2-2h9" />
                      </svg>
                      Clonar Produto
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="lista-paginacao" *ngIf="produtosFiltrados.length">
        <div class="paginacao-info">
          {{ totalRegistros }} produto(s) — página {{ paginaAtual }} de {{ totalPaginas }}
        </div>
        <div class="paginacao-controles">
          <select [(ngModel)]="itensPorPagina" (ngModelChange)="onItensPorPaginaChange()">
            <option *ngFor="let n of opcoesPorPagina" [value]="n">{{ n }} por página</option>
          </select>
          <button type="button" class="btn-pag" (click)="irParaPagina(1)"
            [disabled]="paginaAtual === 1" title="Primeira página">«</button>
          <button type="button" class="btn-pag" (click)="irParaPagina(paginaAtual - 1)"
            [disabled]="paginaAtual === 1" title="Página anterior">‹</button>

          <ng-container *ngIf="paginas[0] > 1">
            <button type="button" class="btn-pag" (click)="irParaPagina(1)">1</button>
            <span class="btn-pag-reticencias" *ngIf="paginas[0] > 2">…</span>
          </ng-container>

          <button type="button" class="btn-pag" *ngFor="let p of paginas" [class.ativo]="p === paginaAtual"
            (click)="irParaPagina(p)">{{ p }}</button>

          <ng-container *ngIf="paginas[paginas.length - 1] < totalPaginas">
            <span class="btn-pag-reticencias" *ngIf="paginas[paginas.length - 1] < totalPaginas - 1">…</span>
            <button type="button" class="btn-pag" (click)="irParaPagina(totalPaginas)">{{ totalPaginas }}</button>
          </ng-container>

          <button type="button" class="btn-pag" (click)="irParaPagina(paginaAtual + 1)"
            [disabled]="paginaAtual === totalPaginas" title="Próxima página">›</button>
          <button type="button" class="btn-pag" (click)="irParaPagina(totalPaginas)"
            [disabled]="paginaAtual === totalPaginas" title="Última página">»</button>
        </div>
      </div>

      <div class="legenda-linhas" *ngIf="produtosFiltrados.length">
        <span class="legenda-item"><span class="legenda-dot legenda-dot-vermelho"></span>Preço Desatualizado</span>
        <span class="legenda-item"><span class="legenda-dot legenda-dot-amarelo"></span>Sem Preço</span>
      </div>
    </ng-container>
  </div>
</div>
